export default __webpack_public_path__ + "static/media/5.9b843371.jpg";